var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C26.2091 44 28 42.2091 28 40C28 37.7909 26.2091 36 24 36C21.7909 36 20 37.7909 20 40C20 42.2091 21.7909 44 24 44Z",
    fill: "#0F2957",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C26.2091 12 28 10.2091 28 8C28 5.79086 26.2091 4 24 4C21.7909 4 20 5.79086 20 8C20 10.2091 21.7909 12 24 12Z",
    fill: "#0F2957",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.686 39.314C14.8952 39.314 16.686 37.5232 16.686 35.314C16.686 33.1049 14.8952 31.314 12.686 31.314C10.4769 31.314 8.68604 33.1049 8.68604 35.314C8.68604 37.5232 10.4769 39.314 12.686 39.314Z",
    fill: "#0F2957",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.314 16.686C37.5231 16.686 39.314 14.8951 39.314 12.686C39.314 10.4768 37.5231 8.68597 35.314 8.68597C33.1048 8.68597 31.314 10.4768 31.314 12.686C31.314 14.8951 33.1048 16.686 35.314 16.686Z",
    fill: "#0F2957",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 28.002C10.2103 28.002 12.002 26.2102 12.002 24C12.002 21.7897 10.2103 19.998 8.00005 19.998C5.7898 19.998 3.99805 21.7897 3.99805 24C3.99805 26.2102 5.7898 28.002 8.00005 28.002Z",
    fill: "#0F2957",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28C42.2091 28 44 26.2091 44 24C44 21.7909 42.2091 20 40 20C37.7909 20 36 21.7909 36 24C36 26.2091 37.7909 28 40 28Z",
    fill: "#0F2957",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.686 16.688C14.8952 16.688 16.686 14.8971 16.686 12.688C16.686 10.4788 14.8952 8.68799 12.686 8.68799C10.4769 8.68799 8.68604 10.4788 8.68604 12.688C8.68604 14.8971 10.4769 16.688 12.686 16.688Z",
    fill: "#0F2957",
    fillOpacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.314 39.316C37.5231 39.316 39.314 37.5251 39.314 35.316C39.314 33.1068 37.5231 31.316 35.314 31.316C33.1048 31.316 31.314 33.1068 31.314 35.316C31.314 37.5251 33.1048 39.316 35.314 39.316Z",
    fill: "#0F2957",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.505f334f86f07aabf13eec75b4815ca6.svg";
export { ForwardRef as ReactComponent };